var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPost = function SvgPost(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18.5,
    "data-width-28": 21,
    "data-width-72": 56,
    viewBox: "0 0 15 15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 1.2h-10a1.3 1.3 0 0 0-1.3 1.3v10a1.3 1.3 0 0 0 1.3 1.3h10a1.3 1.3 0 0 0 1.3-1.3v-10a1.3 1.3 0 0 0-1.3-1.3M2.5 0A2.5 2.5 0 0 0 0 2.5v10A2.5 2.5 0 0 0 2.5 15h10a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 12.5 0zm1.132 3.632V8.53h7.736V3.632zm-.2-1.2a1 1 0 0 0-1 1V8.73a1 1 0 0 0 1 1h8.136a1 1 0 0 0 1-1V3.432a1 1 0 0 0-1-1zm-.594 8.725a.6.6 0 1 0 0 1.2h3.648a.6.6 0 0 0 0-1.2z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPost);
export default ForwardRef;